import * as React from 'react';
export const ETSvg = React.forwardRef(function ETSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'm9.747 7.302-1.14.003a.158.158 0 0 1-.15-.11l-.353-1.084a.158.158 0 0 0-.302 0l-.351 1.084a.158.158 0 0 1-.151.11H6.16a.158.158 0 0 0-.093.286l.922.67c.055.04.079.112.057.178l-.352 1.084a.158.158 0 0 0 .245.177l.921-.618a.16.16 0 0 1 .187 0l.922.618a.158.158 0 0 0 .245-.177L8.86 8.439a.158.158 0 0 1 .057-.178l.922-.67a.16.16 0 0 0-.093-.29Z',
      }),
    ),
  );
});
ETSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ET = {
  category: 'flag',
  colorable: false,
  name: 'ET',
  svg: ETSvg,
};
